import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import {
  Lists_nguonkinhphi, Lists_tinhchatnguonkp, Lists_tieumuc, Lists_khachhang
  , Lists_chuong, Lists_loaikhoan, Lists_cmmt, Lists_hoatdong, Lists_caphat
  , Lists_mathongke, Lists_nganhang
} from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-giaydenghithanhtoan_c2_03edit',
  templateUrl: './giaydenghithanhtoan_c2_03edit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./giaydenghithanhtoan_c2_03edit.component.scss'],
  providers: [ListService, Repository]
})


export class giaydenghithanhtoan_c2_03editComponent implements OnInit {

  doituongSelect1: any = {
    Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
    , KTT_Password: null, CTK_UserName: null, CTK_Password: null
    , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null
    , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de: null
    , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
    , NguoiKy: null, v_tg_gui_dvc: null
    , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
    , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
    , Cer_ktt: null, Cer_ctk: null, hash_file: null
    , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
    , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
    , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
  };
   

  hienthikyso: boolean = false;
  public ngayghitang: Date = null;
  msg: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  indLoading: boolean = false;
  selectednguons: any;
  selectedchuongs: any;
  selectedkhoans: any;
  selecteddoituongs: any;
  selectednganhangs: any;
  selectedctmts: any;
  selectedmucs: any;
  selectedcapphats: any;
  selectedkinhphis: any;
  modalTitle: any;
  inputkinhphis: any = [
    { Id: '008111', Ma_Doi_Tuong: "Kinh phí thường xuyên", Ten_Doi_Tuong: 'Kinh phí thường xuyên' },
    { Id: '008121', Ma_Doi_Tuong: "Kinh phí không thường xuyên", Ten_Doi_Tuong: 'Kinh phí không thường xuyên' },
    { Id: '00911', Ma_Doi_Tuong: "Kinh phí xây dựng cơ bản", Ten_Doi_Tuong: 'Kinh phí xây dựng cơ bản' },
  ];


  doituongSelect: any = {
    Id: null
    , Nguon: null
    , Chuong: null
    , Khoan: null
    , CapPhat: null
    , KinhPhi: null
    , CTMT: null
    , TaiKhoanNH: null
    , DoiTuong: null
    , Tich_TamUng: null, Tich_UngTruoc: null
    , LoaiMau: null, NamKHV: null, SoCanCu: null, NgayCanCu: null, SoDu: null,NoiDung: null
    //, ThanhToans: []
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;
  sobanghi: number;

  //@ViewChild('modal_dvckbnn', { static: false }) modal_dvckbnn: ModalComponent;
  //@ViewChild('dtthamdvckbnnedit', { static: false }) dtthamdvckbnnedit: any;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();

  inputtaikhoans: any;
  inputnguonkinhphis: any;
  inputchuongs: any;
  inputkhoans: any;
  inputctmts: any;
  inputdoituongs: any;
  inputnganhangs: any;
  inputcapphats: any;
  inputmucs: any;
  inputmuc_timkiems: any;
  timkiem_ma: any;
  timkiem_ten: any;
  timkiem_phanhe: any;
  tichtatca: boolean = false;
  public currentUser;
  TichTatCa() {
    this.inputmuc_timkiems.forEach((item: any) => {
      item.Tich = !this.tichtatca;
    });
    //this.inputmucs.forEach((item: any) => {
    //  item.Tich = this.tichtatca;
    //});
  }
  TichDT(value) {
    this.inputmuc_timkiems.forEach((item: any) => {
      if (item.Id == value.Id)
        item.Tich = value.Tich;
    });
  }
  changesearch(value) {
    let datatam = this.inputmuc_timkiems;
    //console.log(datatam);
    if (this.timkiem_ma != "" && this.timkiem_ma != null)
      datatam = datatam.filter((s) => s['Ma_Doi_Tuong'] !== null && s['Ma_Doi_Tuong'].toString().toLowerCase().indexOf(this.timkiem_ma.toLowerCase()) !== -1);
    if (this.timkiem_ten != "" && this.timkiem_ten != null)
      datatam = datatam.filter((s) => s['Ten_Doi_Tuong'] !== null && s['Ten_Doi_Tuong'].toString().toLowerCase().indexOf(this.timkiem_ten.toLowerCase()) !== -1);
    if (this.timkiem_phanhe != "" && this.timkiem_phanhe != null)
      datatam = datatam.filter((s) => s['PhanHe'] !== null && s['PhanHe'].toString().toLowerCase().indexOf(this.timkiem_phanhe.toLowerCase()) !== -1);

    this.inputmucs = datatam;

  }
  comboSearchFn_DT(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }

  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;

  loadDataInit(idchungtu: any, donviid: string, loaimau: number) {

    //loaimau =1 giấy đề nghị thanh toán
    // loaimau=2 giấy đề nghị thanh toán mẫu 5c
    // loaimau=3 giấy đề nghị thu hồi vốn 04b/TT\

    if (loaimau == 1)
      this.hienthikyso = true;

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);
      var giatri = this.currentUser.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    this.repo.getRequest("api/doituong/getall2/" + Lists_nguonkinhphi.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputnguonkinhphis = response;
      });
   this.repo.postRequest('api/doituong/dsmuc', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: this.currentUser.id_don_vi })
      .subscribe(response => {
        this.inputmucs = response;
        this.inputmuc_timkiems = response;
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_chuong.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputchuongs = response;
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_loaikhoan.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputkhoans = response.filter(name => name.Parent !== null);
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_cmmt.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputctmts = response;
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_caphat.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputcapphats = response;
      });
    this.repo.getRequest("api/doituong/getall2/" + Lists_nganhang.id + '/null/' + this.currentUser.id_don_vi)
      .subscribe(response => {
        this.inputnganhangs = response;
      });



   

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
   
    this.doituongSelect = {
      Id: null
      , Nguon: null
      , Chuong: null
      , Khoan: null
      , CapPhat: null
      , KinhPhi: null
      , CTMT: null
      , TaiKhoanNH: null
      , DoiTuong: null
      , Tich_TamUng: null, Tich_UngTruoc: null, LoaiPhieu: null
      , LoaiMau: null, NamKHV: null, SoCanCu: null, NgayCanCu: null, SoDu: null,NoiDung: null
    };
    //this.repo.getRequest("api/doituong/thongtinbangkethanhtoan_tt39/" + idchungtu)
    //  .subscribe(response => {
    //    this.doituongSelect.ThanhToans = response;
    //   });
    this.doituongSelect.Id = idchungtu;
    this.doituongSelect.Tich_TamUng = true;
    this.doituongSelect.Tich_UngTruoc = false;
    this.doituongSelect.DonViId = donviid;
    this.doituongSelect.LoaiMau = loaimau;




    this.doituongSelect1.Id = idchungtu;
    this.doituongSelect1.DonViId = donviid;
    this.doituongSelect1.LoaiMau = 6;
    this.repo.postRequest("api/dvcapi/getbyid_dvc_thamso", this.doituongSelect1)
      .subscribe(response => {

        //console.log("taitai12333333_1");
        //console.log(response.ThamSo); 

        if (response != null && response.ThamSo != null && response.ThamSo != "") {
          let data = JSON.parse(response.ThamSo);
          //this.doituongSelect = data;

          this.doituongSelect.Id = data.Id;
          this.doituongSelect.Nguon = data.Nguon;
          this.doituongSelect.Chuong = data.Chuong;
          this.doituongSelect.Khoan = data.Khoan;
          this.doituongSelect.CapPhat = data.CapPhat;
          this.doituongSelect.KinhPhi = data.KinhPhi;
          this.doituongSelect.CTMT = data.CTMT;
          this.doituongSelect.TaiKhoanNH = data.TaiKhoanNH;
          this.doituongSelect.DoiTuong = data.DoiTuong;
          this.doituongSelect.Tich_TamUng = data.Tich_TamUng;
          this.doituongSelect.Tich_UngTruoc = data.Tich_UngTruoc;
          this.doituongSelect.LoaiPhieu = data.LoaiPhieu;
          this.doituongSelect.LoaiMau = data.LoaiMau;
          this.doituongSelect.NamKHV = data.NamKHV;
          this.doituongSelect.SoCanCu = data.SoCanCu;
          this.doituongSelect.NgayCanCu = data.NgayCanCu;
          this.doituongSelect.SoDu = data.SoDu;
          this.doituongSelect.NoiDung = data.NoiDung;
          


          if (this.doituongSelect.TaiKhoanNH != null && this.doituongSelect.TaiKhoanNH != "") {
            this.selectednganhangs = [];
            let myArray = this.doituongSelect.TaiKhoanNH.split(",");
            myArray.forEach(
              (it) => {
                this.selectednganhangs.push(it);
              }
            );
            
          }
          if (this.doituongSelect.Nguon != null && this.doituongSelect.Nguon != "") {
            this.selectednguons = [];
            let myArray = this.doituongSelect.Nguon.split(",");
            myArray.forEach(
              (it) => {
                this.selectednguons.push(it);
              }
            );
          }

          if (this.doituongSelect.Khoan != null && this.doituongSelect.Khoan != "") {
            this.selectedkhoans = [];
            let myArray = this.doituongSelect.Khoan.split(",");
            myArray.forEach(
              (it) => {
                this.selectedkhoans.push(it);
              }
            );
          }

          if (this.doituongSelect.KinhPhi != null && this.doituongSelect.KinhPhi != "") {
            this.selectedkinhphis = [];
            let myArray = this.doituongSelect.KinhPhi.split(",");
            myArray.forEach(
              (it) => {
                this.selectedkinhphis.push(it);
              }
            );
          }

          if (this.doituongSelect.CapPhat != null && this.doituongSelect.CapPhat != "") {
            this.selectedcapphats = [];
            let myArray = this.doituongSelect.CapPhat.split(",");
            myArray.forEach(
              (it) => {
                this.selectedcapphats.push(it);
              }
            );
          }

          if (this.doituongSelect.CTMT != null && this.doituongSelect.CTMT != "") {
            this.selectedctmts = [];
            let myArray = this.doituongSelect.CTMT.split(",");
            myArray.forEach(
              (it) => {
                this.selectedctmts.push(it);
              }
            );
          }

         
          //console.log("taitai12333333");
          //console.log(this.selectednganhangs);
          //this.doituongSelect.Id = idchungtu;
        }

        this.doituongSelect1.v_ma_ho_so = response.v_ma_ho_so;
        this.doituongSelect1.v_tieu_de = response.v_tieu_de;

      });




    }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  public ngxCurrencyOptions2 = {
    prefix: '',
    thousands: '',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  itemrow: any;
  public changerange(row: any) {
    //if (this.doituongSelect.ThanhToans != null) {
    //  for (let i: number = 0; i < this.doituongSelect.ThanhToans.length; i = i + 1) {
    //    this.itemrow = this.doituongSelect.ThanhToans[i];
    //    if (this.itemrow.IDCHUNGTU == row.IDCHUNGTU && row.NOPTHUE != null && this.itemrow.SOTIENDK!=null) {
    //        this.doituongSelect.ThanhToans[i].DONVIHUONG = this.doituongSelect.ThanhToans[i].SOTIENDK - this.doituongSelect.ThanhToans[i].NOPTHUE;
    //    }
    //  }
    //}
  }
  public tuychinhmaubaocao() {
    let id = BaoCao.BC08_02_GiayDeNghiThanhToanC2_03;
    if (this.doituongSelect.LoaiMau == 2)
      id = BaoCao.BC08_03_GiayDeNghiThanhToan05C;

    if (this.doituongSelect.LoaiMau == 3)
      id = '0B199515-6349-4EB2-8901-D591F5B6D9E0';

    this.dtsuamaubaocao.loadDataInit(id);
    this.modaltuychinhmaubc.open();
  }
  public export(kieuin) {

   

    $('#loading').show();
    if (this.ngayghitang != null)
      this.doituongSelect.NgayCanCu = this.ngayghitang.getDate() + '/' + (this.ngayghitang.getMonth() + 1) + '/' + this.ngayghitang.getFullYear();


    let dsctmt = "";
    if (this.selectedctmts != null) {
        for (var i1 = 0; i1 < this.selectedctmts.length; i1++) {
          if (dsctmt == "")
            dsctmt = this.selectedctmts[i1];
          else
            dsctmt = dsctmt + "," + this.selectedctmts[i1];
        }
        this.doituongSelect.CTMT = dsctmt;
    }
    let dsnguon = "";
    if (this.selectednguons != null) {
        for (var i1 = 0; i1 < this.selectednguons.length; i1++) {
          if (dsnguon == "")
            dsnguon = this.selectednguons[i1];
          else
            dsnguon = dsnguon + "," + this.selectednguons[i1];
      }
      this.doituongSelect.Nguon = dsnguon;
    }
    

    let dschuong = "";
    if (this.selectedchuongs != null) {
        for (var i1 = 0; i1 < this.selectedchuongs.length; i1++) {
          if (dschuong == "")
            dschuong = this.selectedchuongs[i1];
          else
            dschuong = dschuong + "," + this.selectedchuongs[i1];
        }
        this.doituongSelect.Chuong = dschuong;
      }
    
    let dskhoan = "";
      if (this.selectedkhoans != null) {
        for (var i1 = 0; i1 < this.selectedkhoans.length; i1++) {
          if (dskhoan == "")
            dskhoan = this.selectedkhoans[i1];
          else
            dskhoan = dskhoan + "," + this.selectedkhoans[i1];
        }
        this.doituongSelect.Khoan = dskhoan;
      }
    let dscapphat = "";
      if (this.selectedcapphats != null) {
        for (var i1 = 0; i1 < this.selectedcapphats.length; i1++) {
          if (dscapphat == "")
            dscapphat = this.selectedcapphats[i1];
          else
            dscapphat = dscapphat + "," + this.selectedcapphats[i1];
        }
        this.doituongSelect.CapPhat = dscapphat;
      }
    let dsnganhang = "";
      if (this.selectednganhangs != null) {
        for (var i1 = 0; i1 < this.selectednganhangs.length; i1++) {
          if (dsnganhang == "")
            dsnganhang = this.selectednganhangs[i1];
          else
            dsnganhang = dsnganhang + "," + this.selectednganhangs[i1];
        }
        this.doituongSelect.TaiKhoanNH = dsnganhang;
    }


    //console.log("taitai12333333");
    //console.log(this.selectednganhangs);

    let dskinhphi = "";
    if (this.selectedkinhphis != null) {
      for (var i1 = 0; i1 < this.selectedkinhphis.length; i1++) {
        if (dskinhphi == "")
          dskinhphi = this.selectedkinhphis[i1];
        else
          dskinhphi = dskinhphi + "," + this.selectedkinhphis[i1];
      }
      this.doituongSelect.KinhPhi = dskinhphi;
    }
    this.doituongSelect.DoiTuong = "";
      this.inputmuc_timkiems.forEach((item: any) => {
        if (item.Tich === true) {
          if (this.doituongSelect.DoiTuong == "")
            this.doituongSelect.DoiTuong = item.Id;
          else
            this.doituongSelect.DoiTuong = this.doituongSelect.DoiTuong + "," + item.Id;
        }
    });


    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);

    this.repo.postRequest("api/dvcapi/addorupdate_thamso", this.doituongSelect1)
      .subscribe(response => {
        // lưu tham số
      });


    let data = {
      Id: BaoCao.BC08_02_GiayDeNghiThanhToanC2_03, 
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "giay_de_nghi_thanh_toan_tam_ung_c2_03.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }




  export_xml(loaiphieu) {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng
   
    $('#loading').show();
    let dsctmt = "";
    if (this.selectedctmts != null) {
      for (var i1 = 0; i1 < this.selectedctmts.length; i1++) {
        if (dsctmt == "")
          dsctmt = this.selectedctmts[i1];
        else
          dsctmt = dsctmt + "," + this.selectedctmts[i1];
      }
      this.doituongSelect.CTMT = dsctmt;
    }
    let dsnguon = "";
    if (this.selectednguons != null) {
      for (var i1 = 0; i1 < this.selectednguons.length; i1++) {
        if (dsnguon == "")
          dsnguon = this.selectednguons[i1];
        else
          dsnguon = dsnguon + "," + this.selectednguons[i1];
      }
      this.doituongSelect.Nguon = dsnguon;
    }


    let dschuong = "";
    if (this.selectedchuongs != null) {
      for (var i1 = 0; i1 < this.selectedchuongs.length; i1++) {
        if (dschuong == "")
          dschuong = this.selectedchuongs[i1];
        else
          dschuong = dschuong + "," + this.selectedchuongs[i1];
      }
      this.doituongSelect.Chuong = dschuong;
    }

    let dskhoan = "";
    if (this.selectedkhoans != null) {
      for (var i1 = 0; i1 < this.selectedkhoans.length; i1++) {
        if (dskhoan == "")
          dskhoan = this.selectedkhoans[i1];
        else
          dskhoan = dskhoan + "," + this.selectedkhoans[i1];
      }
      this.doituongSelect.Khoan = dskhoan;
    }
    let dscapphat = "";
    if (this.selectedcapphats != null) {
      for (var i1 = 0; i1 < this.selectedcapphats.length; i1++) {
        if (dscapphat == "")
          dscapphat = this.selectedcapphats[i1];
        else
          dscapphat = dscapphat + "," + this.selectedcapphats[i1];
      }
      this.doituongSelect.CapPhat = dscapphat;
    }
    let dsnganhang = "";
    if (this.selectednganhangs != null) {
      for (var i1 = 0; i1 < this.selectednganhangs.length; i1++) {
        if (dsnganhang == "")
          dsnganhang = this.selectednganhangs[i1];
        else
          dsnganhang = dsnganhang + "," + this.selectednganhangs[i1];
      }
      this.doituongSelect.TaiKhoanNH = dsnganhang;
    }
    let dskinhphi = "";
    if (this.selectedkinhphis != null) {
      for (var i1 = 0; i1 < this.selectedkinhphis.length; i1++) {
        if (dskinhphi == "")
          dskinhphi = this.selectedkinhphis[i1];
        else
          dskinhphi = dskinhphi + "," + this.selectedkinhphis[i1];
      }
      this.doituongSelect.KinhPhi = dskinhphi;
    }
    this.doituongSelect.DoiTuong = "";
    this.inputmuc_timkiems.forEach((item: any) => {
      if (item.Tich === true) {
        if (this.doituongSelect.DoiTuong == "")
          this.doituongSelect.DoiTuong = item.Id;
        else
          this.doituongSelect.DoiTuong = this.doituongSelect.DoiTuong + "," + item.Id;
      }
    });
    this.doituongSelect.LoaiPhieu = loaiphieu;
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.doituongSelect)
    };


    this.repo.postRequest("api/baocao/ketnoikbnn_giaydenghithanhtoan/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }

  savedvc(doituong: any) {
    //this.modal_dvckbnn.dismiss();
  }
  kysodvc() {
    //if (this.selectedRows == null || this.selectedRows == "") {
    //  swal('Cảnh báo!', 'Chưa chọn chứng từ để in!.', 'warning');
    //  return;
    //}
    //let idchungtu = "";
    //this.selectedRows.forEach((item: any) => {
    //  idchungtu = item.Id;
    //  if (idchungtu != null)
    //    return true;
    //});
    //this.dtthamdvckbnnedit.loadDataInit(this.doituongSelect, this.currentUser.id_don_vi, 6);
    //this.modal_dvckbnn.open();
  }




}
